module.exports = __webpack_public_path__ + "static/media/snapshift-1.a303c423.png";